import { createAction } from 'typesafe-actions';
import { IAvoBugAssignment } from '../../types/model/avoBug/avoBugAssignment';

export default class AvoBugActions {
    public static setLoadingAssignments = createAction('AVOBUG_SET_LOADING_ASSIGNMENTS', resolve => (loading : boolean) => resolve(loading));
    public static setAssignments = createAction('AVOBUG_SET_ASSIGNMENTS', resolve => (list : Array<IAvoBugAssignment>) => resolve(list));
}
